import {toggleClass} from './dom';

export const splitTextInTarget = (target,delimiter='') => {
  const {textContent} = target;

  while(target.firstChild) target.removeChild(target.firstChild);

  const {length} = textContent.split(delimiter).map((char,index) => {
    const charElement = document.createElement('span');
    charElement.innerHTML = char.split(/\s/).join(' ');
    charElement.style.setProperty('--index',index);
    target.appendChild(charElement);
  });

  target.style.setProperty('--length',length);

  toggleClass(target,'split-text',true);

  return target;
}

export default function textSplitter(selector='.split-text',delimiter='') {
  if(Array.isArray(selector)) selector = selector.join(',');
  const targets = Array.from(document.querySelectorAll(selector));
  return targets.map(target => splitTextInTarget(target,delimiter));
}